// extracted by mini-css-extract-plugin
export default {"panel":"dOI4E2PMdQApkBJ0jWga","open":"ZE_RvkOluUxk7t0h5ckE"};